import { render } from "./CountersDetail.vue?vue&type=template&id=469d13aa&scoped=true"
import script from "./CountersDetail.vue?vue&type=script&lang=js"
export * from "./CountersDetail.vue?vue&type=script&lang=js"

import "./CountersDetail.vue?vue&type=style&index=0&id=469d13aa&scoped=true&lang=css"

import exportComponent from "../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469d13aa"]])

export default __exports__